import { useContext } from "react";
import LoadingPageContext from "../../components/Context/LoadingContext";

export const useLoading = () => {
  const loadingContext = useContext(LoadingPageContext);
  return loadingContext.current;
};